import { EnterpriseLinkButton } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { EmptyStateProps, IconName, Table, TableHeader, TableProvider, TableState } from '@optimus-web/core';
import { useTemplatesTableColumns } from './hooks/useTemplatesTableColumns';
import { TemplatesTableData, TemplatesTableRowData } from './types';

interface TemplatesTableProps {
    data: TemplatesTableData;
    loading: boolean;
    tableState: TableState<TemplatesTableRowData>;
    onTableStateChange: (newState: TableState<TemplatesTableRowData>) => void;
}

export const TemplatesTable = ({ data, loading, tableState, onTableStateChange }: TemplatesTableProps) => {
    const columns = useTemplatesTableColumns();
    const emptyStateProps = {
        primaryText: lt('ContractsNoTemplatesFoundPrimaryText'),
        secondaryText: lt('ContractsNoTemplatesFoundSecondaryText'),
        action: (
            <EnterpriseLinkButton icon={IconName.Add} to="Settings/ReservationContracts/Template/Create" size="small">
                {lt('ContractTemplateAddButtonLabel')}
            </EnterpriseLinkButton>
        ),
        size: 'large',
        pictogram: 'search',
    } satisfies EmptyStateProps;

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={onTableStateChange} as="div">
            <TableHeader
                title={lt('ContractsTemplateTableTitle')}
                globalSearch
                rightSide={
                    <EnterpriseLinkButton
                        icon={IconName.Add}
                        to="Settings/ReservationContracts/Template/Create"
                        size="small"
                    >
                        {lt('ContractTemplateAddButtonLabel')}
                    </EnterpriseLinkButton>
                }
            />
            <Table
                fixedFirstColumn
                uniqueRowId="id"
                data={data}
                amountOfRows={data?.length ?? 0}
                loading={loading}
                emptyState={emptyStateProps}
            />
        </TableProvider>
    );
};
